import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body py-5" }
const _hoisted_3 = { class: "row g-5 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-lg-7" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://images.empoweredconsumerism-static-files.com/ovi/sealpro/seal_pro_banner.jpg",
    alt: "Seal Pro",
    class: "seq-coverage-banner__img w-100"
  })
], -1)
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "seq-coverage-hero" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "seq-coverage-hero__label" }, "Your Maximum Coverage", -1)
const _hoisted_8 = { class: "seq-coverage-hero__amount" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "seq-coverage-hero__hint" }, " Total protection available across your active Seal Pro policies. ", -1)
const _hoisted_10 = { class: "card-body pt-6 pb-0" }
const _hoisted_11 = { class: "card-header border-0 pt-5" }
const _hoisted_12 = { class: "card-title align-items-center" }
const _hoisted_13 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Coverage Details", -1)
const _hoisted_15 = { class: "card-body py-3" }
const _hoisted_16 = {
  key: 0,
  class: "text-center text-muted py-10"
}
const _hoisted_17 = {
  key: 1,
  class: "seq-coverage-list"
}
const _hoisted_18 = { class: "seq-coverage-list__thumb" }
const _hoisted_19 = { class: "seq-coverage-list__body" }
const _hoisted_20 = { class: "fw-semibold text-gray-800 fs-6" }
const _hoisted_21 = { class: "seq-trend-up fw-bold fs-5 my-1" }
const _hoisted_22 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_23 = { class: "text-muted fs-8" }
const _hoisted_24 = {
  key: 0,
  class: "seq-coverage-list__action"
}
const _hoisted_25 = {
  type: "button",
  ref: "renewNowSealproModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#renew_now_sealpromodal`
}
const _hoisted_26 = {
  type: "button",
  ref: "renewNowSealproModalButton2",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_renewal_sealpromodal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_SealProRenew = _resolveComponent("SealProRenew")
  const _component_SealProEncode = _resolveComponent("SealProEncode")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      (Number(_ctx.sealProMaxCoverage) > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: [_ctx.widgetClasses, "card seq-card mb-6"]
          }, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.sealProMaxCoverage).toFixed(2))), 1),
                    _hoisted_9
                  ])
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_DashboardTabNavigator)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("h3", _hoisted_12, [
            _createVNode("span", _hoisted_13, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
            ]),
            _hoisted_14
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          (_ctx.activeCoverage.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_16, " No active coverages found. "))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeCoverage, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "seq-coverage-list__item"
                  }, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("img", {
                        src: '/media/ovi_coverages/' + item.packageType + '.webp',
                        alt: item.packageType
                      }, null, 8, ["src", "alt"])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, " ECOC: " + _toDisplayString(item.coi), 1),
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.numberWithCommas(Number(item.amount).toFixed(2))), 1),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("span", {
                          class: ["seq-badge", _ctx.coverageBadgeClass(item)]
                        }, _toDisplayString(_ctx.coverageStatusLabel(item)), 3),
                        _createVNode("span", _hoisted_23, _toDisplayString(_ctx.formatCoverageDate(item.form_date)) + " – " + _toDisplayString(_ctx.formatCoverageDate(item.expire_date)), 1)
                      ])
                    ]),
                    (item.coveragests === 'EXPIRED' || item.coveragests === 'EXPIRING')
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-seq-green",
                            onClick: ($event: any) => (_ctx.renewSealPro(item))
                          }, " Renew Policy ", 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ])
      ], 2),
      _withDirectives(_createVNode("button", _hoisted_25, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProRenew, {
        key: _ctx.renew_now_sealpro_key,
        renewCoverage: _ctx.renewCoverage,
        sealpro_encode_modal: 'renew_now_sealpromodal'
      }, null, 8, ["renewCoverage"]),
      _withDirectives(_createVNode("button", _hoisted_26, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        key: _ctx.renew_now_sealpro_key,
        firstCoverage: _ctx.renewCoverage,
        sealpro_encode_modal: 'encode_renewal_sealpromodal',
        isRenewal: true,
        allowClose: true,
        inputActivationDetail: false,
        isAddAccount: false,
        allowChangeName: false
      }, null, 8, ["firstCoverage"])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}